import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import {
  Keywords,
  Mattype,
  Facet,
  CurrentFilter,
  AuthSeeAlso,
  AuthSymbol,
  locationCollectionResponse,
} from 'src/app/models/walai';
import { SearchService } from 'src/app/services/search.service';
import { HomeService } from 'src/app/services/home.service';
import {
  UntypedFormGroup,
  FormBuilder,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';

import * as $ from 'jquery';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../services/data.service';
import { AdminService } from '../services/admin.service';
import { PageEvent } from '@angular/material/paginator';
import { ApiConfig, ConfigService } from '../services/config.service';

import { MoreFilterDialogComponent } from './more-filter-dialog/more-filter-dialog.component';
@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.css'],
})
export class ResultsComponent implements OnInit {
  bookList: any;
  baseUrl: string = '';
  auth: AuthSeeAlso[] = [];
  BT: AuthSeeAlso;
  NT: AuthSeeAlso;
  RT: AuthSeeAlso;
  LV: AuthSeeAlso;
  UF: AuthSeeAlso;
  AuthSymbol: AuthSymbol[] = [];
  AuthViewOPAC: string = '';

  bookcount = '...';
  keyword: Keywords;
  Mattype: Mattype;
  CurrentFilter: Array<CurrentFilter> = []; //คำที่ค้น
  CurrentKeyword: Array<CurrentFilter> = []; //คำที่ค้น
  _DisplayStyle: string = 'List';

  Ntk: any[];
  Ntt: any[];
  Nto: any[];

  locationID: string;
  locationName: string;

  qsearchForm: UntypedFormGroup;

  notEmptyPost = true;
  notscrolly = true;

  allFacet: Facet[];
  subjectFacet: Array<Facet> = [];
  subjectFacetLess: Array<Facet> = [];
  subjectFacetLessShow: boolean = true;

  authorFacet: Array<Facet> = [];
  authorFacetLess: Array<Facet> = [];
  authorFacetLessShow: boolean = true;

  locationFacet: Array<Facet> = [];
  locationFacetLess: Array<Facet> = [];
  locationFacetLessShow: boolean = true;

  sourceTypeFacet: Array<Facet> = [];
  sourceTypeFacetLess: Array<Facet> = [];
  sourceTypeFacetLessShow: boolean = true;

  collectionFacet: Array<Facet> = [];
  collectionFacetLess: Array<Facet> = [];
  collectionFacetLessShow: boolean = true;
  locationCollectionData: locationCollectionResponse[] = [];

  langFacet: Array<Facet> = [];
  langFacetLess: Array<Facet> = [];
  langFacetLessShow: boolean = true;

  RegionFacet: Array<Facet> = [];
  RegionFacetLess: Array<Facet> = [];
  RegionFacetLessShow: boolean = true;

  EraFacet: Array<Facet> = [];
  EraFacetLess: Array<Facet> = [];
  EraFacetLessShow: boolean = true;

  CallNoLCFacet: Array<Facet> = [];
  CallNoLCFacetLess: Array<Facet> = [];
  CallNoLCFacetLessShow: boolean = true;

  CallNoDCFacet: Array<Facet> = [];
  CallNoDCFacetLess: Array<Facet> = [];
  CallNoDCFacetLessShow: boolean = true;

  CallNoNLMFacet: Array<Facet> = [];
  CallNoNLMFacetLess: Array<Facet> = [];
  CallNoNLMFacetLessShow: boolean = true;

  IllustrationsFacet: Array<Facet> = [];
  IllustrationsFacetLess: Array<Facet> = [];
  IllustrationsFacetLessShow: boolean = true;

  TargetAudienceFacet: Array<Facet> = [];
  TargetAudienceFacetLess: Array<Facet> = [];
  TargetAudienceFacetLessShow: boolean = true;

  FormofItemFacet: Array<Facet> = [];
  FormofItemFacetLess: Array<Facet> = [];
  FormofItemFacetLessShow: boolean = true;

  NatureOfContentsFacet: Array<Facet> = [];
  NatureOfContentsFacetLess: Array<Facet> = [];
  NatureOfContentsFacetLessShow: boolean = true;

  GovernmentPublicationFacet: Array<Facet> = [];
  GovernmentPublicationFacetLess: Array<Facet> = [];
  GovernmentPublicationFacetLessShow: boolean = true;

  ConferencePublicationFacet: Array<Facet> = [];
  ConferencePublicationFacetLess: Array<Facet> = [];
  ConferencePublicationFacetLessShow: boolean = true;

  FestschriftFacet: Array<Facet> = [];
  FestschriftFacetLess: Array<Facet> = [];
  FestschriftFacetLessShow: boolean = true;

  LiteraryFormFacet: Array<Facet> = [];
  LiteraryFormFacetLess: Array<Facet> = [];
  LiteraryFormFacetLessShow: boolean = true;

  BiographyFacet: Array<Facet> = [];
  BiographyFacetLess: Array<Facet> = [];
  BiographyFacetLessShow: boolean = true;

  facetLess: number = 6;
  year_max = 0;
  year_min = 0;
  year_Cmin_value = 0;
  year_Cmax_value = 0;
  // minYear: number;
  // maxYear: number;

  // minYearValue: number = 0;
  // maxYearValue: number = 0;
  //optionsYear: Options;
  // optionsYear: Options = {
  //   floor: 0,
  //   ceil: 0,
  // };
  // options: Options = {
  //   floor: 1000,
  //   ceil: 2563,
  // };
  showSubject: number = 1;
  showAuthor: number = 1;
  showlocation: number = 1;
  showMattype: number = 1;
  showPubyear: number = 1;
  showCollection: number = 1;
  showLang: number = 1;
  showRegion: number = 1;
  showEra: number = 1;
  showCallNoLC: number = 1;
  showCallNoDC: number = 1;
  showCallNoNLM: number = 1;
  showIllustrations: number = 1;
  showTargetAudience: number = 1;
  showFormofItem: number = 1;
  showNatureOfContents: number = 1;
  showGovernmentPublication: number = 1;
  showConferencePublication: number = 1;
  showFestschrift: number = 1;
  showLiteraryForm: number = 1;
  showBiography: number = 1;

  inputState: string = 'Keyword';

  suggesterWord: string[] = [];
  pageEvent: PageEvent;
  Page: number = 1;
  Size: number = 24;
  recordCount: number = 0;
  imgBannerUrl = {}; // URL ของภาพปกหนังสือที่ใช้แสดงผลเบื้องต้น
  private _apiconfig: ApiConfig;
  private apiUrl = '';

  filterSortOption: 'alphabetical' | 'count' = 'alphabetical';

  isRefindedSearch: boolean = false; //  ค้นจากผลลัพธ์การค้นหาเดิม

  constructor(
    private route: ActivatedRoute,
    private searchService: SearchService,
    private homeService: HomeService,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private data: DataService,
    private adminService: AdminService,
    private router: Router,
    private configService: ConfigService,
    private modalService: NgbModal
  ) {
    this._apiconfig = this.configService.apiConfig;
    this.apiUrl = this._apiconfig.url;

    this.adminService.getLogoBanner('banner').subscribe((data: any) => {
      if (data) {
        const img = new Image();
        img.onload = () => {
          // โหลดรูปสำเร็จ
          this.imgBannerUrl = {
            'background-image': 'url(' + data + ')',
          };
        };
        img.onerror = () => {
          // โหลดรูปไม่สำเร็จ ใช้ default
          this.imgBannerUrl = {
            'background-image':
              'url(assets/images/Banner.jpg), url(assets/images/Banner4.jpg)',
          };
        };
        img.src = data;
      }
    });
  }

  ngOnInit(): void {
    if (localStorage.getItem('locationCollectionResponse') != null) {
      this.locationCollectionData = JSON.parse(localStorage.getItem('locationCollectionResponse'));
    }

    this.spinner.show();
    this.loadFacetDisplay();
    //โหลดมาครั้งแรก

    // ไว้ซ่อน Menu bar ส่วน Filter ด้านซ้าย กรณีที่เป็น UI Mobile
    $('#menu-toggle').click(function (e) {
      e.preventDefault();
      $('#wrapper').toggleClass('toggled');
    });

    this.baseUrl = `${this.apiUrl}/api/BookKeywordSearchRSS/`;

    //โหลดครั้งแรกให้แสดงผลปกหนังสือ
    this._DisplayStyle =
      localStorage.getItem('DisplayStyle') != null
        ? localStorage.getItem('DisplayStyle')
        : this.configService.displayBookResult;

    //ดึงค่าตัวแปรสาขามาเพื่อใช้เป็นตัวกรองการสืบค้น
    this.locationID = localStorage.getItem('locationIDMain'); //location หลัก
    this.locationName = localStorage.getItem('locationNameMain');

    this.keyword = new Keywords(); //ตัวแปรแบบ  Object ใช้เพื่อส่งค่าไปยัง API การสืบค้น โดยโหลดมาครั้งแรกจะไปตัดมาจาก Get URL
    if (this.route.snapshot.queryParamMap.get('Ntk')) {
      this.keyword.Ntk = this.route.snapshot.queryParamMap.get('Ntk');
    } else {
      this.keyword.Ntk = 'KEYWORD';
    }

    if (this.route.snapshot.queryParamMap.get('Ntt')) {
      if (this.route.snapshot.queryParamMap.get('Ntt').includes('||')) {
        this.keyword.Ntt = this.route.snapshot.queryParamMap
          .get('Ntt')
          .split('||')[0];
      } else {
        this.keyword.Ntt = this.route.snapshot.queryParamMap.get('Ntt');
      }
    } else {
      this.keyword.Ntt = '';
    }

    if (this.route.snapshot.queryParamMap.get('Nto')) {
      this.keyword.Nto = this.route.snapshot.queryParamMap.get('Nto');
    } else {
      this.keyword.Nto = '';
    }

    if (this.route.snapshot.queryParamMap.get('CurrentPage')) {
      this.keyword.CurrentPage = Number(
        this.route.snapshot.queryParamMap.get('CurrentPage')
      );
    } else {
      this.keyword.CurrentPage = 1;
    }
    if (this.route.snapshot.queryParamMap.get('RowPerPage')) {
      this.keyword.RowPerPage = Number(
        this.route.snapshot.queryParamMap.get('RowPerPage')
      );
    } else {
      this.keyword.RowPerPage = this.Size; //24;
    }
    if (this.route.snapshot.queryParamMap.get('Orderby')) {
      this.keyword.Orderby = this.route.snapshot.queryParamMap.get('Orderby');
    } else {
      this.keyword.Orderby = 'RELEVANCE';
    }

    this.keywordSearch(this.keyword);

    try {
      // Don't use FACULTYID, PROGRAMID, or COURSECODE as the default search state/text in the input box
      const ntk = this.CurrentKeyword[0].Ntk.toUpperCase();
      const isSpecialSearch = ntk === 'FACULTYID' || ntk === 'PROGRAMID' || ntk === 'COURSECODE';

      this.inputState = isSpecialSearch ? 'KEYWORD' : this.CurrentKeyword[0].Ntk;

      //ดึงค่าคำค้นตัวแรกไปแสดงใน  TextBox
      const initialSearchText = (isSpecialSearch || this.Ntt[0] === '*') ? '' : this.Ntt[0];

      this.qsearchForm = new UntypedFormGroup({
        textSearch: new UntypedFormControl(initialSearchText),
        typeOption: new UntypedFormControl(this.inputState),
      });

      if (initialSearchText) {
        this.Suggester(initialSearchText);
      }
    } catch (error) {
      this.qsearchForm = new UntypedFormGroup({
        textSearch: new UntypedFormControl(''),
        typeOption: new UntypedFormControl('KEYWORD'),
      });
    }
  }

  toggleRefineSearch() {
    this.isRefindedSearch = !this.isRefindedSearch;
  }

  openMoreFilterDialog(
    filterType: string,
    filterName: string,
    facets: Facet[]
  ): void {
    const modalRef = this.modalService.open(MoreFilterDialogComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.filters = facets; // Pass filters to the modal
    modalRef.componentInstance.filterName = filterName; // Pass filter type to the modal
    modalRef.result.then(
      (result) => {
        // call  addFilter function with the selected filter
        if (result) {
          this.addFilter(filterType, result.name);
        }
        // Handle the result from the modal here
      },
      (reason) => {
        // Handle 'Cross click' or other dismissal reasons here
      }
    );
  }

  pageNavigations(event?: PageEvent) {
    this.Page = event.pageIndex;
    this.Size = event.pageSize;

    this.PageEventChange(this.Page + 1);
  }

  PageEventChange(page: number) {
    this.keyword.CurrentPage = page;
    const navigationExtras: NavigationExtras = {
      queryParams: {
        Ntk: this.keyword.Ntk,
        Ntt: this.keyword.Ntt,
        Nto: this.keyword.Nto,
        CurrentPage: this.keyword.CurrentPage,
      },
    };
    this.router.navigate(['/results'], navigationExtras);

    // Scroll to the search results section with offset
    setTimeout(() => {
      const searchResults = document.querySelector('.search-results');
      if (searchResults) {
        const elementPosition = searchResults.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - 100; // 100px offset from top

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 100);

    this.searchService.keywordsearch(this.keyword).subscribe(
      (results: any) => {
        if (results) {
       
          this.bookList = results.Display;
          this.spinner.hide();
        }
      },
      (error) => { }
    );
  }

  loadFacetDisplay() {
    this.adminService.getFacetSetting().subscribe(
      (setting: any[]) => {
        if (!setting || !Array.isArray(setting)) return;
        setting.forEach((element) => {
          switch (element.ENG) {
            case 'Nature of contents':
              this.showNatureOfContents = element.DISPLAY;
              break;
            case 'Government publication':
              this.showGovernmentPublication = element.DISPLAY;
              break;
            case 'Conference publication':
              this.showConferencePublication = element.DISPLAY;
              break;
            case 'Festschrift':
              this.showFestschrift = element.DISPLAY;
              break;
            case 'Literary form':
              this.showLiteraryForm = element.DISPLAY;
              break;
            case 'Biography':
              this.showBiography = element.DISPLAY;
              break;
            case 'Author':
              this.showAuthor = element.DISPLAY;
              break;
            case 'Subject':
              this.showSubject = element.DISPLAY;
              break;
            case 'Pubyear':
              this.showPubyear = element.DISPLAY;
              break;
            case 'Mattype':
              this.showMattype = element.DISPLAY;
              break;
            case 'Menber Library':
              this.showlocation = element.DISPLAY;
              break;
            case 'Lang':
              this.showLang = element.DISPLAY;
              break;
            case 'Geo Area':
              this.showRegion = element.DISPLAY;
              break;
            case 'Era':
              this.showEra = element.DISPLAY;
              break;
            case 'Call no LC':
              this.showCallNoLC = element.DISPLAY;
              break;
            case 'Call no DC':
              this.showCallNoDC = element.DISPLAY;
              break;
            case 'Call no NLM':
              this.showCallNoNLM = element.DISPLAY;
              break;
            case 'Illustrations':
              this.showIllustrations = element.DISPLAY;
              break;
            case 'Target audience':
              this.showTargetAudience = element.DISPLAY;
              break;
            case 'Form of item':
              this.showFormofItem = element.DISPLAY;
              break;
            case 'Collection':
              this.showCollection = element.DISPLAY;
              break;
            default:
              break;
          }
        });
      },
      (error) => {
        console.error('Error loading facet settings', error);
      }
    );
  }

  loadRSS() {
    this.baseUrl =
      `${this.apiUrl}/api/BookKeywordSearchRSS/` +
      this.keyword.Ntk +
      '/' +
      this.keyword.Ntt +
      '/' +
      this.keyword.Nto;
    if (this.keyword.Nto == '') {
      this.baseUrl =
        `${this.apiUrl}/api/BookKeywordSearchRSS/` +
        this.keyword.Ntk +
        '/' +
        this.keyword.Ntt +
        '/0';
    }
    //window.location.href =  this.baseUrl ;
    window.open(
      this.baseUrl,
      '_blank' // <- This is what makes it open in a new window.
    );
  }

  //ดึงข้อมูล Auth
  Auth(keyword_: Keywords) {
    this.AuthSymbol = [];
    this.auth = [];
    //ส่งคำไปสืบค้นและรอ Api
    this.searchService.AuthSeeAlso(keyword_).subscribe(
      (results: AuthSeeAlso[]) => {
        if (results) {
          this.auth = results;

          this.auth.forEach((element) => {
            switch (element.REF) {
              case 'Broader Term':
                // BT: AuthSeeAlso;
                this.BT = element;
                break;
              case 'Narrower Term':
                // NT: AuthSeeAlso;
                this.NT = element;
                break;
              case 'Related Term':
                // RT: AuthSeeAlso;
                this.RT = element;
                break;
              case 'Language Variants':
                // LV: AuthSeeAlso
                this.LV = element;
                break;
              case 'Used For':
                // UF: AuthSeeAlso
                this.UF = element;
                break;
              default:
                break;
            }
          });
        } else {
        }
      },
      (error) => { }
    );
  }

  showAuth(authID: string, type: string) {
    this.AuthSymbol = [];
    this.searchService.AuthSymbol(authID, type).subscribe(
      (results: AuthSymbol[]) => {
        if (results) {
          this.AuthSymbol = results;
        } else {
          this.AuthSymbol = [];
        }
      },
      (error) => {
        this.AuthSymbol = [];
      }
    );
  }

  Suggester(keyword: string) {
    if (!keyword || keyword.trim().length < 2 || keyword === '*') {
      this.suggesterWord = [];
      return;
    }
    this.suggesterWord = [];
    this.searchService
      .keywordSuggester({
        Keyword: keyword,
      })
      .subscribe(
        (results: string[]) => {
          if (results) {
            this.suggesterWord = results;
          } else {
            this.suggesterWord = [];
          }
        },
        (error) => {
          this.suggesterWord = [];
        }
      );
  }

  searchAuth(authID, AuthViewOPAC) {
    this.AuthViewOPAC = AuthViewOPAC;
    //ดึง Location ที่มีการใส่ไว้ใน  localStorage มาส่งเพิ่มใน Function สืบค้น เพราะในระบบนี้มีการแสดงผลแบบแยก Location เป็นหลัก
    this.locationID = localStorage.getItem('locationIDMain'); //location หลัก
    this.locationName = localStorage.getItem('locationNameMain');

    //เพิ่มค่าให้แก่ตัวแปร  Keyword Ntk คือประเภทการสืบค้น Ntt คือคำค้น Nto คือ Operator ที่ใช้สำหรับคำค้นที่มีมากกว่าหนึ่งซึ่งเป็นได้ทั้ง And Or Not
    this.keyword.Ntk = 'AUTHLINK';
    this.keyword.Ntt = authID;

    if (this.locationID != '') {
      //กรณีมีการระบุสาขา ซึ่งถ้าเป็นค่าว่าง จะไม่ระบุสาขา
      this.keyword.Ntk += '|LOCATION';
      this.keyword.Ntt += '|' + this.locationID;
    }
    this.keyword.Nto = '';
    this.keyword.CurrentPage = 1; // CurrentPage หน้าที่แสดงผลในการสืบค้นครั้งใหม่จะเริ่มที่หน้าแรกเสมอ

    this.keywordSearch(this.keyword); //ส่งค่าไปยัง Function การสืบค้น
  }

  //Function การสืบค้นที่มีการไปดึงผลการสืบค้นจาก API
  keywordSearch(keyword_: Keywords) {
    this.recordCount = 0;
    this.Ntk = keyword_.Ntk.split('|'); //ประเภทการสืบค้น
    this.Ntt = keyword_.Ntt.split('|'); //คำค้น
    this.Nto = keyword_.Nto.split('|');

    //แสดงรายการคำค้น ประเภทการสืบค้น และ ตัวกรองต่างๆ ที่ใช้
    this.GetCurrentFilterAndKeyword();
    this.bookList = [];

    //หมุนๆ รอก่อนผลจะมา
    this.spinner.show();

    //ส่งคำไปสืบค้นและรอ Api
    this.searchService.keywordsearch(keyword_).subscribe(
      (results: any) => {
        
        if (results) {
          this.bookcount = results.Counts[0].Count; //จำนวนผลการสืบค้น
          try {
            this.recordCount = Number(this.bookcount);
          } catch (error) { }

          this.bookList = results.Display; //รายการหนังสือที่เจอ
          this.allFacet = results.Narrow; //ตัวกรองทั้งหมด

          this.getFacet(); //แสดงรายละเอียดของตัวกรองด้านซ้าย
        } else {
          this.setNull(); //ในกรณีไม่พบผลลัพธ์การสืบค้นให้ Set ตัวแปรต่างๆ เป็นค่าว่าง เพื่อให้ Control ที่แสดงผลเป็นค่าว่างๆ ผู้ใช้จะได้ไม่ งง
        }
        this.spinner.hide(); //ซ่อนตัวหมุนๆ
      },
      (error) => {
        //ในกรณี Error  ให้ Set ตัวแปรต่างๆ เป็นค่าว่าง เพื่อให้ Control ที่แสดงผลเป็นค่าว่างๆ ผู้ใช้จะได้ไม่ งง
        this.setNull();
        this.spinner.hide();
      }
    );

    this.Auth(this.keyword);
  }

  removeSlash(text: string): string {
    if (!text) return '';
    return text.trim().replace(/\/$/, '');
  }

  ConvertCurrentFilterAndKeywordToText(key: CurrentFilter) {
    // {{ item.Ntk }} : {{ item.Ntt }}

    switch (key.Ntk.toUpperCase()) {
      case 'MEDIATYPE':
        return this.getMEDIATYPENameByID(key.Ntt);
      case 'FACULTYID':
        const langDiv = localStorage.getItem('lang') || 'th';
        const allCurrRaw = localStorage.getItem('allCurriculum');
        if (allCurrRaw) {
          const allCurriculum = JSON.parse(allCurrRaw);
          const faculty = allCurriculum.find(f => f.FACULTYID == key.Ntt);
          if (faculty) {
            return langDiv === 'en' ? faculty.FACULTYNAMEENG : faculty.FACULTYNAMETHAI;
          }
        }
        return key.Ntt;
      case 'PROGRAMID':
        const langProg = localStorage.getItem('lang') || 'th';
        const resFacRaw = localStorage.getItem('resultFaculty');
        if (resFacRaw) {
          const resFac = JSON.parse(resFacRaw);
          let foundProg: any = null;
          resFac.levelgroup.forEach(level => {
            const prog = level.programGroup.find(p => p.PROGRAMID == key.Ntt);
            if (prog) foundProg = prog;
          });
          if (foundProg) {
            return langProg === 'en' ? foundProg.PROGRAMNAMEENG : foundProg.PROGRAMNAMETHAI;
          }
        }
        return key.Ntt;
      default:
        return key.Ntt;
    }
  }

  getMEDIATYPENameByID(id) {
    const type = [
      'Unknow',
      'Book',
      'Continuing Resources',
      'Music',
      'Map',
      'Visual Materials',
      'Computer Files',
      'Mixed Materials',
      '',
      'Article',
      'ebook',
    ];
    return type[id];
  }

  getCollectionDisplayName(name: string): string {
    if (!this.locationCollectionData || this.locationCollectionData.length === 0) {
      return name;
    }

    for (const location of this.locationCollectionData) {
      if (location.collections) {
        const found = location.collections.find(c => String(c.Value) === String(name));
        if (found) {
          return found.DISPLAY;
        }
      }
    }
    return name;
  }

  //แสดงเรายการคำค้นและ Filter ด้านซ้าย
  GetCurrentFilterAndKeyword() {
    //Set ค่าว่างการเสมอ มีประโยชน์ในการโหลดครั้งแรกและเมื่อผลลัพธ์ Error
    this.CurrentFilter = [];
    this.CurrentKeyword = [];

    for (let index = 0; index < this.Ntk.length; index++) {
      const k = this.Ntk[index];
      const t = this.Ntt[index];
      let Filter: CurrentFilter;
      Filter = new CurrentFilter();
      Filter.Ntk = k;
      Filter.Ntt = t;
      Filter.id = t;
      switch (k.toUpperCase()) {
        case 'LOCATION':
          this.homeService.getLocationName(t).subscribe(
            (locationName: string) => {
              Filter.Ntt = locationName;
            },
            (error) => {
              this.setNull();
            }
          );

          Filter.id = t;
          this.CurrentFilter.push(Filter);
          break;
        case 'SUBJECTFACET':
        case 'AUTHORFACET':
        case 'PUBYEAR':
        case 'MEDIATYPE':
        case 'MATTYPE':
        case 'COLLECTION':
          Filter.Ntt = this.getCollectionDisplayName(t);
          this.CurrentFilter.push(Filter);
          break;
        case 'LANG':
        case 'REGION':
        case 'ERA':
        case 'CALLNOLC':
        case 'CALLNODC':
        case 'CALLNONLM':
        case 'ILLUSTRATIONS':
        case 'TARGETAUDIENCE':
        case 'FORMOFITEM':
        case 'NATUREOFCONTENTS':
        case 'GOVERNMENTPUBLICATION':
        case 'CONFERENCEPUBLICATION':
        case 'FESTSCHRIFT':
        case 'LITERARYFORM':
        case 'BIOGRAPHY':
          if (k.toUpperCase() === 'MEDIATYPE' || k.toUpperCase() === 'MATTYPE') {
            Filter.Ntt = this.getMEDIATYPENameByID(t);
          }
          this.CurrentFilter.push(Filter);
          break;
        case 'AUTHLINK':
          Filter.Ntt = this.AuthViewOPAC;
          Filter.id = t;
          this.CurrentKeyword.push(Filter);
          break;
        case 'FACULTYID':
          const lang_f = localStorage.getItem('lang') || 'th';
          const allCurrRaw_f = localStorage.getItem('allCurriculum');
          Filter.id = t; // Store original ID for removal
          if (allCurrRaw_f) {
            const allCurriculum_ = JSON.parse(allCurrRaw_f);
            // Use loose equality (==) in case t is a string and FACULTYID is a number, or vice versa
            const faculty_ = allCurriculum_.find(f => f.FACULTYID == t);
            if (faculty_) {
              Filter.Ntt = lang_f === 'en' ? faculty_.FACULTYNAMEENG : faculty_.FACULTYNAMETHAI;
            }
          }
          this.CurrentKeyword.push(Filter);
          break;
        case 'PROGRAMID':
          const lang_p = localStorage.getItem('lang') || 'th';
          const resFacRaw_p = localStorage.getItem('resultFaculty');
          Filter.id = t; // Store original ID for removal
          if (resFacRaw_p) {
            const resFac_ = JSON.parse(resFacRaw_p);
            let foundProg_: any = null;
            resFac_.levelgroup.forEach(level => {
              const prog = level.programGroup.find(p => p.PROGRAMID == t);
              if (prog) foundProg_ = prog;
            });
            if (foundProg_) {
              Filter.Ntt = lang_p === 'en' ? foundProg_.PROGRAMNAMEENG : foundProg_.PROGRAMNAMETHAI;
            }
          }
          this.CurrentKeyword.push(Filter);
          break;
        case 'COURSECODE':
          Filter.id = t; // Store original ID for removal
          this.CurrentKeyword.push(Filter);
          break;
        default:
          //จะสกัด Filter ออกเป็น Case ก่อนหน้าและถ้าเป็น Case อื่นๆ ก็ให้มองเป็น คำค้น
          this.CurrentKeyword.push(Filter);
      }
    }
  }

  //Set ค่าว่างให้ตัวแปลที่ใช้แสดงผลใน Control ต่างๆ เพื่อผลที่ดีสำหรับกรณีไม่มีข้อมูลมาแสดงผล
  setNull() {
    this.bookcount = null;
    this.subjectFacet = [];
    this.subjectFacetLess = [];

    this.authorFacet = [];
    this.authorFacetLess = [];

    this.locationFacet = [];
    this.locationFacetLess = [];

    this.sourceTypeFacet = [];
    this.sourceTypeFacetLess = [];

    this.collectionFacet = [];
    this.collectionFacetLess = [];

    this.langFacet = [];
    this.langFacetLess = [];

    this.RegionFacet = [];
    this.RegionFacetLess = [];

    this.EraFacet = [];
    this.EraFacetLess = [];

    this.CallNoLCFacet = [];
    this.CallNoLCFacetLess = [];

    this.CallNoDCFacet = [];
    this.CallNoDCFacetLess = [];

    this.CallNoNLMFacet = [];
    this.CallNoNLMFacetLess = [];

    this.IllustrationsFacet = [];
    this.IllustrationsFacetLess = [];

    this.TargetAudienceFacet = [];
    this.TargetAudienceFacetLess = [];

    this.FormofItemFacet = [];
    this.FormofItemFacetLess = [];

    this.NatureOfContentsFacet = [];
    this.NatureOfContentsFacetLess = [];

    this.GovernmentPublicationFacet = [];
    this.GovernmentPublicationFacetLess = [];

    this.ConferencePublicationFacet = [];
    this.ConferencePublicationFacetLess = [];

    this.FestschriftFacet = [];
    this.FestschriftFacetLess = [];

    this.LiteraryFormFacet = [];
    this.LiteraryFormFacetLess = [];

    this.BiographyFacet = [];
    this.BiographyFacetLess = [];
  }

  //แสดงรายการ Facet หรือ Filter Result โดยแต่ละประเภทการ Filter จะมีการแยกไปยังตัวแปลคนละตัวกัน
  getFacet() {
    this.subjectFacet = [];
    this.subjectFacetLess = [];

    this.authorFacet = [];
    this.authorFacetLess = [];

    this.locationFacet = [];
    this.locationFacetLess = [];

    this.sourceTypeFacet = [];
    this.sourceTypeFacetLess = [];

    this.collectionFacet = [];
    this.collectionFacetLess = [];

    this.langFacet = [];
    this.langFacetLess = [];

    this.RegionFacet = [];
    this.RegionFacetLess = [];

    this.EraFacet = [];
    this.EraFacetLess = [];

    this.CallNoLCFacet = [];
    this.CallNoLCFacetLess = [];

    this.CallNoDCFacet = [];
    this.CallNoDCFacetLess = [];

    this.CallNoNLMFacet = [];
    this.CallNoNLMFacetLess = [];

    this.IllustrationsFacet = [];
    this.IllustrationsFacetLess = [];

    this.TargetAudienceFacet = [];
    this.TargetAudienceFacetLess = [];

    this.FormofItemFacet = [];
    this.FormofItemFacetLess = [];

    this.NatureOfContentsFacet = [];
    this.NatureOfContentsFacetLess = [];

    this.GovernmentPublicationFacet = [];
    this.GovernmentPublicationFacetLess = [];

    this.ConferencePublicationFacet = [];
    this.ConferencePublicationFacetLess = [];

    this.FestschriftFacet = [];
    this.FestschriftFacetLess = [];

    this.LiteraryFormFacet = [];
    this.LiteraryFormFacetLess = [];

    this.BiographyFacet = [];
    this.BiographyFacetLess = [];

    let isubject: number = 0;
    let iauthor: number = 0;
    let ilocation: number = 0;
    let isourceType: number = 0;
    let firstYear: boolean = true;

    let icollection: number = 0;
    let ilang: number = 0;
    let iRegion: number = 0;
    let iEra: number = 0;
    let iCallNoLC: number = 0;
    let iCallNoDC: number = 0;
    let iCallNoNLM: number = 0;
    let iIllustrations: number = 0;
    let iTargetAudience: number = 0;
    let iFormofItem: number = 0;
    let iNatureOfContents: number = 0;
    let iGovernmentPublication: number = 0;
    let iConferencePublication: number = 0;
    let iFestschrift: number = 0;
    let iLiteraryForm: number = 0;
    let iBiography: number = 0;

    //  collection
    //  lang
    //   Region
    //   Era
    //   CallNoLC
    //   CallNoDC
    //   CallNoNLM
    //   Illustrations
    //   TargetAudience
    //   FormofItem
    //   NatureOfContents
    //   GovernmentPublication
    //   ConferencePublication
    //   Festschrift
    //   LiteraryForm
    //   Biography

    //นำค่าที่ได้จาก Function สืบค้น ของ API ในส่วนที่เป็น Facet มาวนแยกเพื่อใส่ลงไปตามประเภทของตัวแปรที่ได้เตรียมไว้
    if (this.allFacet && Array.isArray(this.allFacet)) {
      this.allFacet.forEach((element) => {
        switch (element.Type) {
          case 'subjectfacet':
            this.subjectFacet.push(element);
            isubject += 1;
            if (isubject <= this.facetLess) {
              this.subjectFacetLess.push(element);
            }
            break;
          case 'authorfacet':
            this.authorFacet.push(element);
            iauthor += 1;
            if (iauthor <= this.facetLess) {
              this.authorFacetLess.push(element);
            }
            break;
          case 'location':
            this.locationFacet.push(element);
            ilocation += 1;
            if (ilocation <= this.facetLess) {
              this.locationFacetLess.push(element);
            }
            break;
          case 'Biography':
            this.BiographyFacet.push(element);
            iBiography += 1;
            if (iBiography <= this.facetLess) {
              this.BiographyFacetLess.push(element);
            }
            break;
          case 'LiteraryForm':
            this.LiteraryFormFacet.push(element);
            iLiteraryForm += 1;
            if (iLiteraryForm <= this.facetLess) {
              this.LiteraryFormFacetLess.push(element);
            }
            break;
          case 'Festschrift':
            this.FestschriftFacet.push(element);
            iFestschrift += 1;
            if (iFestschrift <= this.facetLess) {
              this.FestschriftFacetLess.push(element);
            }
            break;
          case 'ConferencePublication':
            this.ConferencePublicationFacet.push(element);
            iConferencePublication += 1;
            if (iConferencePublication <= this.facetLess) {
              this.ConferencePublicationFacetLess.push(element);
            }
            break;
          case 'GovernmentPublication':
            this.GovernmentPublicationFacet.push(element);
            iGovernmentPublication += 1;
            if (iGovernmentPublication <= this.facetLess) {
              this.GovernmentPublicationFacetLess.push(element);
            }
            break;
          case 'NatureOfContents':
            this.NatureOfContentsFacet.push(element);
            iNatureOfContents += 1;
            if (iNatureOfContents <= this.facetLess) {
              this.NatureOfContentsFacetLess.push(element);
            }
            break;
          case 'FormofItem':
            this.FormofItemFacet.push(element);
            iFormofItem += 1;
            if (iFormofItem <= this.facetLess) {
              this.FormofItemFacetLess.push(element);
            }
            break;
          case 'TargetAudience':
            this.TargetAudienceFacet.push(element);
            iTargetAudience += 1;
            if (iTargetAudience <= this.facetLess) {
              this.TargetAudienceFacetLess.push(element);
            }
            break;
          case 'Illustrations':
            this.IllustrationsFacet.push(element);
            iIllustrations += 1;
            if (iIllustrations <= this.facetLess) {
              this.IllustrationsFacetLess.push(element);
            }
            break;
          case 'CallNoNLM':
            this.CallNoNLMFacet.push(element);
            iCallNoNLM += 1;
            if (iCallNoNLM <= this.facetLess) {
              this.CallNoNLMFacetLess.push(element);
            }
            break;
          case 'CallNoDC':
            this.CallNoDCFacet.push(element);
            iCallNoDC += 1;
            if (iCallNoDC <= this.facetLess) {
              this.CallNoDCFacetLess.push(element);
            }
            break;
          case 'CallNoLC':
            this.CallNoLCFacet.push(element);
            iCallNoLC += 1;
            if (iCallNoLC <= this.facetLess) {
              this.CallNoLCFacetLess.push(element);
            }
            break;
          case 'Era':
            this.EraFacet.push(element);
            iEra += 1;
            if (iEra <= this.facetLess) {
              this.EraFacetLess.push(element);
            }
            break;
          case 'Region':
            this.RegionFacet.push(element);
            iRegion += 1;
            if (iRegion <= this.facetLess) {
              this.RegionFacetLess.push(element);
            }
            break;
          case 'lang':
            this.langFacet.push(element);
            ilang += 1;
            if (ilang <= this.facetLess) {
              this.langFacetLess.push(element);
            }
            break;
          case 'collection':
            this.collectionFacet.push(element);
            icollection += 1;
            if (icollection <= this.facetLess) {
              this.collectionFacetLess.push(element);
            }
            break;
          case 'pubyear':
            if (Number(element.name)) {
              if (firstYear == true) {
                // ค่าแรกสุดเป็นค่าตั้งต้นให้ตัวแปร
                this.year_min = Number(element.name);
                this.year_max = Number(element.name);
                firstYear = false;
              } else {
                if (Number(element.name) > this.year_max) {
                  this.year_max = Number(element.name);
                }
                if (Number(element.name) < this.year_min) {
                  this.year_min = Number(element.name);
                }
              }
            }

            break;
          case 'mattype':
            this.sourceTypeFacet.push(element);
            isourceType += 1;
            if (isourceType <= this.facetLess) {
              this.sourceTypeFacetLess.push(element);
            }
            break;
          default:
            break;
        }
      });
    }

    this.year_Cmin_value = this.year_min;
    this.year_Cmax_value = this.year_max;
    // this.PrepareYear();
  }

  //จัดการข้อมูลปีพิมพ์
  // PrepareYear() {
  //   // this.minYear =  Number(element.name);
  //   // this.maxYear =  Number(element.name);
  //   // this.optionsYear = {
  //   //   floor: this.minYear,
  //   //   ceil: this.maxYear,
  //   // };

  //   //alert( this.optionsYear.floor);
  //   // this.minYearValue = this.minYear;
  //   // this.maxYearValue = this.maxYear;
  // }

  //เมื่อกดปุ่มดูเพิ่มเติมของ Subject
  MoreSubject(value) {
    this.subjectFacetLessShow = value;
  }

  //เมื่อกดปุ่มดูเพิ่มเติมของ Author
  MoreAuthor(value) {
    this.authorFacetLessShow = value;
  }

  //เมื่อกดปุ่มดูเพิ่มเติมของ Location
  MoreLocation(value) {
    this.locationFacetLessShow = value;
  }

  //เมื่อกดปุ่มดูเพิ่มเติมของ collection
  Morecollection(value) {
    this.collectionFacetLessShow = value;
  }

  //เมื่อกดปุ่มดูเพิ่มเติมของ lang
  Morelang(value) {
    this.langFacetLessShow = value;
  }

  //เมื่อกดปุ่มดูเพิ่มเติมของ Region
  MoreRegion(value) {
    this.RegionFacetLessShow = value;
  }

  //เมื่อกดปุ่มดูเพิ่มเติมของ Era
  MoreEra(value) {
    this.EraFacetLessShow = value;
  }

  //เมื่อกดปุ่มดูเพิ่มเติมของ CallNoLC
  MoreCallNoLC(value) {
    this.CallNoLCFacetLessShow = value;
  }

  //เมื่อกดปุ่มดูเพิ่มเติมของ CallNoDC
  MoreCallNoDC(value) {
    this.CallNoDCFacetLessShow = value;
  }

  //เมื่อกดปุ่มดูเพิ่มเติมของ CallNoNLM
  MoreCallNoNLM(value) {
    this.CallNoNLMFacetLessShow = value;
  }

  //เมื่อกดปุ่มดูเพิ่มเติมของ Illustrations
  MoreIllustrations(value) {
    this.IllustrationsFacetLessShow = value;
  }

  //เมื่อกดปุ่มดูเพิ่มเติมของ TargetAudience
  MoreTargetAudience(value) {
    this.TargetAudienceFacetLessShow = value;
  }
  //เมื่อกดปุ่มดูเพิ่มเติมของ FormofItem
  MoreFormofItem(value) {
    this.FormofItemFacetLessShow = value;
  }

  //เมื่อกดปุ่มดูเพิ่มเติมของ NatureOfContents
  MoreNatureOfContents(value) {
    this.NatureOfContentsFacetLessShow = value;
  }

  //เมื่อกดปุ่มดูเพิ่มเติมของ GovernmentPublication
  MoreGovernmentPublication(value) {
    this.GovernmentPublicationFacetLessShow = value;
  }

  //เมื่อกดปุ่มดูเพิ่มเติมของ ConferencePublication
  MoreConferencePublication(value) {
    this.ConferencePublicationFacetLessShow = value;
  }
  //เมื่อกดปุ่มดูเพิ่มเติมของ Festschrift
  MoreFestschrift(value) {
    this.FestschriftFacetLessShow = value;
  }

  //เมื่อกดปุ่มดูเพิ่มเติมของ LiteraryForm
  MoreLiteraryForm(value) {
    this.LiteraryFormFacetLessShow = value;
  }

  //เมื่อกดปุ่มดูเพิ่มเติมของ Biography
  MoreBiography(value) {
    this.BiographyFacetLessShow = value;
  }

  //เมื่อเปลี่ยนรูปแบบการเรียงการสืบค้น
  changeOrderBy(event) {
    //เปลี่ยนแค่ตัวแปรการเรียงอย่างเดียวค่าอื่นๆ ใน Keyword ยังเหมือนเดิม
    const value = event.target.value;
    this.keyword.Orderby = value;
    this.keyword.CurrentPage = 1;

    // Scroll to top when changing sort order
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    //ส่งค่าไปยัง Function Keyword Search
    this.keywordSearch(this.keyword);
  }

  //Function ที่ใช้สืบค้น ของหน้า Result เอง โดยส่งมาจาก Text Search
  search(qsForm: boolean = true, keyword_: string = '') {
    var keyword = keyword_;
    if (qsForm == true) {
      keyword = this.qsearchForm.controls.textSearch.value;
      if (keyword === '') {
        keyword = '*';
      }
    }

    if (keyword != '') {
      if (qsForm == false) {
        this.qsearchForm.controls.textSearch.setValue(keyword);
      }
      window.scroll({
        top: 20,
        left: 0,
        behavior: 'smooth',
      });
      // Textbox Search ด้านบน

      //ดึง Location ที่มีการใส่ไว้ใน  localStorage มาส่งเพิ่มใน Function สืบค้น เพราะในระบบนี้มีการแสดงผลแบบแยก Location เป็นหลัก
      this.locationID = localStorage.getItem('locationIDMain'); //location หลัก
      this.locationName = localStorage.getItem('locationNameMain');

      //เพิ่มค่าให้แก่ตัวแปร  Keyword Ntk คือประเภทการสืบค้น Ntt คือคำค้น Nto คือ Operator ที่ใช้สำหรับคำค้นที่มีมากกว่าหนึ่งซึ่งเป็นได้ทั้ง And Or Not
      // this.keyword.Ntk = 'KEYWORD';
      //เพิ่มค่าให้แก่ตัวแปร  Keyword Ntk คือประเภทการสืบค้น Ntt คือคำค้น Nto คือ Operator ที่ใช้สำหรับคำค้นที่มีมากกว่าหนึ่งซึ่งเป็นได้ทั้ง And Or Not
      // this.keyword.Ntk = 'KEYWORD';
      // เพิ่มการค้นจากผลลัพธ์เดิม isRefindedSearch 

      if (this.isRefindedSearch) {
        //ถ้าเป็นการค้นจากผลลัพธ์เดิม
        this.keyword.Ntk = this.keyword.Ntk + '|' + this.qsearchForm.controls.typeOption.value;
        this.keyword.Ntt = this.keyword.Ntt + '|' + keyword;
        this.keyword.Nto = this.keyword.Nto + '|AND'; //ถ้าเป็นการค้นจากผลลัพธ์เดิมจะใช้ AND เสมอ
      } else {
        //ถ้าเป็นการค้นใหม่
        if (qsForm) {

          this.keyword.Ntk = this.qsearchForm.controls.typeOption.value;
        } else {
          this.keyword.Ntk = 'KEYWORD';
        }
        this.keyword.Ntt = keyword;
      }
      // if (qsForm) {
      //   this.keyword.Ntk = this.qsearchForm.controls.typeOption.value;
      // } else {
      //   this.keyword.Ntk = 'KEYWORD';
      // }

      // this.keyword.Ntt = keyword;

      if (this.locationID != '') {
        //กรณีมีการระบุสาขา ซึ่งถ้าเป็นค่าว่าง จะไม่ระบุสาขา
        this.keyword.Ntk += '|LOCATION';
        this.keyword.Ntt += '|' + this.locationID;
      }
      this.keyword.Nto = '';
      this.keyword.CurrentPage = 1; // CurrentPage หน้าที่แสดงผลในการสืบค้นครั้งใหม่จะเริ่มที่หน้าแรกเสมอ

      const navigationExtras: NavigationExtras = {
        queryParams: {
          Ntk: this.keyword.Ntk,
          Ntt: this.keyword.Ntt,
          Nto: this.keyword.Nto,
          CurrentPage: this.keyword.CurrentPage,
        },
      };
      this.router.navigate(['/results'], navigationExtras);

      this.keywordSearch(this.keyword); //ส่งค่าไปยัง Function การสืบค้น

      if (qsForm) {
        this.Suggester(this.qsearchForm.controls['textSearch'].value);
      }
    }
  }

  //รูปแบบการการแสดงผลซึ่งมี 2 แบบคือแบบเป็นช่องๆ และแบบเแสดงรายละเอียด
  DisplayStyle(Style) {
    this._DisplayStyle = Style;
    localStorage.setItem('DisplayStyle', Style);

    // if (Style === 'Table') {
    //   this.DisplayTable = Style;
    //   this.DisplayList = null;
    // } else {
    //   this.DisplayTable = null;
    //   this.DisplayList = Style;
    // }
  }

  //ใช้สำหรับการแบ่งหน้าแบบเลื่อน Mouse ไว้ล่างสุดเมื่อไปล่างสุด จะมีการไปดึงผลลัพธ์ของหน้าถัดไปมาแสดงต่อท้าย
  onScroll() {
    if (this.notscrolly && this.notEmptyPost) {
      this.spinner.show();
      this.notscrolly = false;
      this.loadNextPost();
    }
  }

  // load th next  posts
  loadNextPost() {
    this.keyword.CurrentPage = this.keyword.CurrentPage + 1;

    this.searchService.keywordsearch(this.keyword).subscribe(
      (results: any) => {
        if (results) {
          const newPost = results.Display;
          this.spinner.hide();
          if (newPost.length === 0) {
            this.notEmptyPost = false;
          }

          // add newly fetched posts to the existing post
          this.bookList = this.bookList.concat(newPost);
          this.notscrolly = true;
        }
      },
      (error) => { }
    );
  }

  // แสงดรายละเอียดของประเภททรัพยากร เนื่องจากหนังสือและวารสารบางชื่อ อาจจะเป็น บทความหรือ E-book ดังนั้นระบบจึงต้องไปตรวจสอบอีกครั้งเพื่อจะได้ประเภทที่ต้องการจริงๆ
  // getMattype(typeid, bibid): Promise<string> {
  //   return new Promise((resolve, _reject) => {
  //     if (typeid != 1 && typeid != 2) {
  //       this.Mattype = new Mattype();
  //       const matName = this.Mattype.GetMattypeName(typeid);
  //       resolve(`assets/images/Mattype/${matName}.png`);
  //     } else {
  //       this.homeService.getBookNewMatType(bibid).subscribe((mid: any) => {
  //         resolve(`assets/images/Mattype/${mid}.png`);
  //       });
  //     }
  //   });
  // }

  //ลบคำค้นจาก Current Keyword ทางด้านซ้าย
  RemoveKeyword(type, word) {
    //keyword จะถูกเชื่อมด้วย | ดังนั้นจะต้องแยกประเภทการสืบค้นและคำค้นต่างๆ ออกจากกันก่อน โดยคำค้นและประเภทนั้นถูกเรียงกันเป็นลำดับอย่างชัดเจนตั้งแต่ส่งมาแล้ว
    this.Ntk = this.keyword.Ntk.split('|');
    this.Ntt = this.keyword.Ntt.split('|');
    this.Nto = this.keyword.Nto.split('|');

    for (let index = 0; index < this.Ntk.length; index++) {
      //วนลบคำค้น
      if (this.Ntk[index] == type && this.Ntt[index] == word) {
        //พบตำแหน่งของคำค้นที่ต้องการลบ *คำและประเภทตรงกัน
        this.Ntk.splice(index, 1);
        this.Ntt.splice(index, 1);
      }
    }

    this.keyword.Ntk = '';
    this.keyword.Ntt = '';
    for (let index = 0; index < this.Ntk.length; index++) {
      //วนลบคำค้น
      this.keyword.Ntk += this.Ntk[index] + '|';
      this.keyword.Ntt += this.Ntt[index] + '|';
    }

    //ตัด | ตัวสุดท้ายออก
    this.keyword.Ntk = this.keyword.Ntk.slice(0, -1);
    this.keyword.Ntt = this.keyword.Ntt.slice(0, -1);

    // ถ้าลบหมดจนไม่มีค่าใน Ntt ให้ตั้งค่าเป็น * (ค้นหาทั้งหมด)
    if (!this.keyword.Ntt || this.keyword.Ntt.trim() === '') {
      this.keyword.Ntt = '*';
      this.keyword.Ntk = 'KEYWORD';
    }

    // Reset to first page when removing filter
    this.keyword.CurrentPage = 1;

    // Update textSearch form control with the first remaining keyword
    // This keeps the search box in sync with the current search state
    const remainingKeywords = this.keyword.Ntt.split('|');
    const remainingTypes = this.keyword.Ntk.split('|');

    // Find the first non-filter keyword to display in search box
    let searchText = '';
    for (let i = 0; i < remainingTypes.length; i++) {
      const upperType = remainingTypes[i].toUpperCase();
      // Check if it's a main search keyword (not a filter)
      if (['KEYWORD', 'TITLE', 'AUTHOR', 'SUBJECT', 'PUBLISHER', 'JOURNALTITLE', 'CALLNUMBER', 'ISBNISSN'].includes(upperType)) {
        searchText = remainingKeywords[i];
        this.inputState = remainingTypes[i];
        break;
      }
    }

    // Update the search form
    if (searchText) {
      this.qsearchForm.controls.textSearch.setValue(searchText === '*' ? '' : searchText);
      this.qsearchForm.controls.typeOption.setValue(this.inputState);
    } else {
      // If no keywords left, set to * (search all)
      this.qsearchForm.controls.textSearch.setValue('');
      this.qsearchForm.controls.typeOption.setValue('KEYWORD');
      this.inputState = 'Keyword';
    }

    // Update URL parameters
    const navigationExtras: NavigationExtras = {
      queryParams: {
        Ntk: this.keyword.Ntk,
        Ntt: this.keyword.Ntt,
        Nto: this.keyword.Nto,
        CurrentPage: this.keyword.CurrentPage,
      },
    };
    this.router.navigate(['/results'], navigationExtras);

    //เมื่อลบคำค้นเรียบร้อยแล้ว จะมีการไปลืบค้นหาผลลัพธ์ใหม่
    // Scroll to top when removing filter
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    this.keywordSearch(this.keyword);
  }

  //เพิ่มตัวกรองการสืบค้น
  addFilter(type, name) {
    this.keyword.CurrentPage = 1;
    //การเพิ่มตัวกรองการสืบค้นทำได้โดยการใช้ | ต่อท้ายคำค้นและประเภทการสืบค้นได้เลย
    this.keyword.Ntk += '|' + type;
    this.keyword.Ntt += '|' + name;

    // Scroll to top when adding filter
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    this.keywordSearch(this.keyword);
  }

  addFilterYear() {
    this.keyword.CurrentPage = 1;
    this.keyword.Ntk += '|PUBYEAR';
    this.keyword.Ntt +=
      '|[ ' + this.year_Cmin_value + ' TO ' + this.year_Cmax_value + ']';

    // Scroll to top when adding year filter
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    this.keywordSearch(this.keyword);
  }

  save(bibid: string) {
    this.data.saveForExport(bibid);
  }

  // เมื่อเปลี่ยนรูปแบบการสืบค้น
  SearchOption(event: string, text: string) {
    this.inputState = text;
    this.qsearchForm.controls.typeOption.setValue(event);
  }

  // แปลงชื่อประเภทตัวกรองเชิงเทคนิคให้เป็น Label ที่อ่านง่าย (สำหรับใช้กับ Translate Pipe)
  getFilterLabel(ntk: string): string {
    switch (ntk.toUpperCase()) {
      case 'LOCATION': return 'Location';
      case 'SUBJECTFACET': return 'Subject';
      case 'AUTHORFACET': return 'Author';
      case 'PUBYEAR': return 'PublishYear';
      case 'MEDIATYPE':
      case 'MATTYPE': return 'SourceType';
      case 'COLLECTION': return 'Collection';
      case 'LANG': return 'Language';
      case 'REGION': return 'Geographic Area';
      case 'ERA': return 'Era';
      case 'CALLNOLC': return 'LC Call Number';
      case 'CALLNODC': return 'Dewey Call Number';
      case 'CALLNONLM': return 'NLM Call Number';
      case 'ILLUSTRATIONS': return 'Illustrations';
      case 'TARGETAUDIENCE': return 'Target Audience';
      case 'FORMOFITEM': return 'Form of Item';
      case 'NATUREOFCONTENTS': return 'Nature of Contents';
      case 'GOVERNMENTPUBLICATION': return 'Government Publication';
      case 'CONFERENCEPUBLICATION': return 'Conference Publication';
      case 'FESTSCHRIFT': return 'Festschrift';
      case 'LITERARYFORM': return 'Literary Form';
      case 'BIOGRAPHY': return 'Biography';
      default: return ntk;
    }
  }

  // ค้นหาใหม่ (Reset ทั้งหมด)
  resetSearch() {
    this.qsearchForm.controls.textSearch.setValue('');
    this.qsearchForm.controls.typeOption.setValue('KEYWORD');
    this.isRefindedSearch = false;
    this.keyword.Ntk = 'KEYWORD';
    this.keyword.Ntt = '*';
    this.keyword.Nto = '';
    this.keyword.CurrentPage = 1;
    this.search(true, '*');
  }

  // Custom Paginator Helper Methods
  getTotalPages(): number {
    return Math.ceil(this.recordCount / this.Size);
  }

  getPageNumbers(): number[] {
    const totalPages = this.getTotalPages();
    const currentPage = this.keyword.CurrentPage;
    const maxPagesToShow = 5; // Show max 5 page numbers at a time
    const pages: number[] = [];

    if (totalPages <= maxPagesToShow + 2) {
      // Show all pages if total is small
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Calculate range around current page
      let startPage = Math.max(2, currentPage - Math.floor(maxPagesToShow / 2));
      let endPage = Math.min(totalPages - 1, startPage + maxPagesToShow - 1);

      // Adjust if we're near the end
      if (endPage === totalPages - 1) {
        startPage = Math.max(2, endPage - maxPagesToShow + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }

    return pages;
  }
}
